import { ForwardedColumn, Row } from 'hatch-components';
import styled from 'styled-components';

const OPTIONS_MENU_WIDTH = 150;

export const StyledOptionsMenu = styled(ForwardedColumn)(
  ({
    transition,
    theme: {
      colors,
      border,
      shadows,
      responsive: { mobile },
    },
    targetRef,
    showOnMobile,
  }) => {
    const { top = 0, left = 0 } =
      targetRef?.current?.getBoundingClientRect() ?? {};
    const offset = 12;

    const topPosition = top;
    const leftPosition = `${left - OPTIONS_MENU_WIDTH - offset}px`;

    return {
      background: colors.white,
      border: `1px solid ${colors.disabled}`,
      borderRadius: border.radius.md,
      boxShadow: shadows.primary,
      left: leftPosition,
      [mobile]: {
        display: showOnMobile ? 'flex' : 'none',
      },
      opacity: transition === 'entered' ? 1 : 0,
      padding: '14px 16px',
      position: 'fixed',
      top: topPosition,
      transition: 'opacity 0.25s ease',
      width: OPTIONS_MENU_WIDTH,
      zIndex: 9999,
    };
  },
);

export const StyledOption = styled(Row)(
  ({ errorStyle, theme: { font, border, spacing, colors } }) => ({
    '&:hover': {
      background: errorStyle ? colors.errorHighlight : colors.primaryHighlight,
      color: errorStyle ? colors.error : colors.primary,
    },
    '&:last-child': {
      marginBottom: 0,
    },
    alignItems: 'center',
    borderRadius: border.radius.sm,
    color: errorStyle ? colors.error : colors.secondary,
    cursor: 'pointer',
    fontSize: font.size.md,
    justifyContent: 'space-between',
    lineHeight: font.lineHeight.md,
    marginBottom: spacing.xs,
    padding: `${spacing.xs} ${spacing.sm}`,
    width: '100%',
  }),
);
